<template>
    <el-card>
        <el-row class="benefit__title">会员权益</el-row>
        <!-- 搜索 -->
        <el-row class="benefit__search">
            <div class="item">
                <span>订阅权益:</span>
                <el-select v-model="searchList.benefitType" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in subscriptionBenefits" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>是否有效:</span>
                <el-select v-model="searchList.status" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>应有场景:</span>
                <el-select v-model="searchList.scene" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in sceneList" :key="index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>权益名称:</span>
                <el-input style="width: 200px;" v-model="searchList.name" placeholder="请输入权益名称" clearable></el-input>
            </div>
            <div class="item">
                <span>权益ID:</span>
                <el-input style="width: 200px;" v-model="searchList.id" placeholder="请输入权益ID" clearable></el-input>
            </div>
            <el-button type="primary" @click="getBenefitList(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                addDialogVisible = true
                addDialogType = 0
            }">添加</el-button>
            <el-button type="info" @click="importBenefit">导入</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="benefitList">
                <el-table-column prop="id" label="权益ID" align="center">
                </el-table-column>
                <el-table-column prop="scene" label="应用场景" align="center">
                    <template slot-scope="scope">
                        {{sceneList.find(item => item == scope.row.scene) || ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="listPicUrl" label="列表图标" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.listPicUrl" style="width: 100px; height: 100px;"
                            :preview-src-list="[scope.row.listPicUrl]" />
                    </template>
                </el-table-column>
                <el-table-column prop="benefitType" label="权益类型" align="center">
                    <template slot-scope="scope">
                        {{subscriptionBenefits.find(item => item.value == scope.row.benefitType)?.name || ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="权益名称" align="center">
                </el-table-column>
                <el-table-column prop="description" label="权益描述" align="center">
                </el-table-column>
                <el-table-column prop="sort" label="排序" align="center" sortable>
                </el-table-column>
                <el-table-column label="详情" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="getDetailList(scope.row, 1)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="userSign" label="会员等级" align="center">
                </el-table-column>
                <el-table-column prop="status" label="是否有效" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.status == 0 ? '禁用' : '启用' }}
                    </template>
                </el-table-column>
                <el-table-column prop="mtime" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDialog(scope.row)"
                            style="margin-bottom: 10px;">编辑</el-button>
                        <el-button type="success" @click="copyBenefit(scope.row)"
                            style="margin-bottom: 10px;">复制</el-button>
                        <el-button type="danger" id="btn" @click="copyToTest(scope.row)">复制到测试服</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 导入 -->
        <el-dialog title="导入" :visible.sync="importVisible" width="50%">
            <el-input type="textarea" style="margin-bottom: 10px;" v-model="importFile" :rows="5"></el-input>
            <el-button type="primary" @click="addBenefit(importFile, () => importVisible = false)">导入</el-button>
            <el-button type="danger" @click="importVisible = false">取消</el-button>
        </el-dialog>
        <!-- 添加/编辑 -->
        <el-dialog :title="addDialogType == 0 ? '添加' : '编辑'" :visible.sync="addDialogVisible" width="50%"
            @close="addDialogClose">
            <el-form :model="addDialogInfo" :rules="ruleList" ref="addDialogForm" label-width="150px">
                <el-form-item label="应用场景" prop="scene">
                    <el-select v-model="addDialogInfo.scene" filterable placeholder="请选择">
                        <el-option v-for="(item, index) in sceneList" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权益名称" prop="name">
                    <el-input style="width: 200px;" v-model="addDialogInfo.name"></el-input>
                </el-form-item>
                <el-form-item label="权益描述" prop="description">
                    <el-input style="width: 200px;" type="textarea" v-model="addDialogInfo.description"></el-input>
                </el-form-item>
                <el-form-item label="权益类型" prop="benefitType">
                    <el-select :disabled="addDialogType == 1" v-model="addDialogInfo.benefitType" filterable
                        placeholder="请选择">
                        <el-option v-for="(item, index) in subscriptionBenefits" :key="index" :label="item.name"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户权益" prop="userSign">
                    <el-select v-model="addDialogInfo.userSign" filterable placeholder="请选择">
                        <el-option v-for="(item, index) in userSignList" :key="index" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input style="width: 200px;" v-model="addDialogInfo.sort"></el-input>
                </el-form-item>
                <el-form-item label="列表图标" prop="listPicUrl">
                    <UploadSingleImg v-model="addDialogInfo.listPicUrl" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="列表动态图标" prop="listDynamicUrl">
                    <UploadSingleImg v-model="addDialogInfo.listDynamicUrl" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="详情图标" prop="dressPicUrl">
                    <UploadSingleImg v-model="addDialogInfo.dressPicUrl" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="详情动态图标" prop="dressDynamicUrl">
                    <UploadSingleImg v-model="addDialogInfo.dressDynamicUrl" :on-upload="uploadFile"></UploadSingleImg>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch v-model="addDialogInfo.status" :active-value="1" :inactive-value="0" active-text="启用"
                        inactive-text="禁用"></el-switch>
                </el-form-item>
            </el-form>
            <el-row style="text-align: right;">
                <el-button type="danger" @click="addDialogClose">取消</el-button>
                <el-button type="primary" @click="submitDialog">确定</el-button>
            </el-row>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="detailVisible" width="60%" @close="closeDetail">
            <el-row>
                <!-- <span style="margin-right: 10px;">{{ this.showName }}:</span>
                <el-input style="width: 200px;margin-right: 10px;" v-model="typesName"></el-input>
                <span style="margin-right: 10px;">天数:</span>
                <el-input style="width: 200px;margin-right: 10px;" v-model="days"></el-input> -->
                <el-col :span="5" style="width: max-content;" v-for="(item, index) in fieldMappings[showIndex]"
                    :key="index">
                    <span style="margin-right: 10px;">{{ item.name }}:</span>
                    <el-select style="width: 120px;margin-right: 10px;" v-if="item.type && item.type == 'select'"
                        v-model="detailInfo.detailData[item.value]" filterable placeholder="请选择">
                        <el-option v-for="(item, index) in signRewardTypeList" :key="index" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-else style="width: 100px;margin-right: 10px;"
                        v-model="detailInfo.detailData[item.value]"></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" @click="addDetail">添加</el-button>
                </el-col>
            </el-row>
            <el-table :data="detailList">
                <!-- <el-table-column :prop="this.showName"
                    :label="fieldMappings.find(item => item.value == this.showName)?.name || ''" align="center">
                </el-table-column>
                <el-table-column prop="validDays" label="天数" align="center"></el-table-column> -->
                <el-table-column v-for="(item, index) in fieldMappings[showIndex]" :key="index" :prop="item.value"
                    :label="item.name" align="center">
                    <template slot-scope="scope">
                        {{item.value == 'signRewardType' ? signRewardTypeList.find(item => item.value ==
                            scope.row.signRewardType)?.name || '' : scope.row[item.value]}}
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="创建人" align="center"></el-table-column>
                <el-table-column prop="mtime" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.status == 0 ? '无效' : '有效' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200px">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDetail(scope.row)">{{
                            scope.row.status == 0 ? '启用' :
                                '禁用' }}</el-button>
                        <el-button type="success" @click="editDetail(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row style="text-align: right;margin-top: 10px;">
                <el-button type="primary" @click="closeDetail">取消</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'
import { getConstList } from '@/api/constRequest'
import Clipboard from 'clipboard'


export default {
    name: 'Benefit',
    components: {
        UploadSingleImg
    },
    data() {
        return {
            //订阅权益
            subscriptionBenefits: [],
            searchList: {
                benefitType: null,
                status: null,
                scene: null,
                name: null,
                id: null,
            },
            // 0:添加 1:编辑
            addDialogType: 0,
            addDialogVisible: false,
            statusList: [
                {
                    value: 0,
                    label: '禁用'
                },
                {
                    value: 1,
                    label: '启用'
                }
            ],
            detailVisible: false,
            addDialogInfo: {
                scene: null,
                name: null,
                description: null,
                benefitType: null,
                userSign: null,
                sort: null,
                listPicUrl: '',
                listDynamicUrl: '',
                dressPicUrl: '',
                dressDynamicUrl: '',
                status: 1,
            },
            sceneList: [
                'VIP',
            ],
            ruleList: {
                'scene': [{ required: true, message: '请选择场景', trigger: 'change' },],
                'name': [{ required: true, message: '请输入权益名称', trigger: 'blur' },],
                'description': [{ required: true, message: '请输入权益描述', trigger: 'blur' },],
                'benefitType': [{ required: true, message: '请选择权益类型', trigger: 'change' },],
                'userSign': [{ required: true, message: '请选择会员等级', trigger: 'change' },],
                'sort': [{ required: true, message: '请输入排序', trigger: 'blur' },],
                'listPicUrl': [{ required: true, message: '请上传列表图标', trigger: 'blur' },],
                // 'listDynamicUrl': [{ required: true, message: '请上传列表动态图标', trigger: 'blur' },],
                // 'dressPicUrl': [{ required: true, message: '请上传详情图标', trigger: 'blur' },],
                // 'dressDynamicUrl': [{ required: true, message: '请上传详情动态图标', trigger: 'blur' },],
            },
            fieldMappings: [
                [
                    { name: '通话折扣百分比', value: 'callDiscount', types: 1 },
                ],
                [
                    { name: '免费消息条数', value: 'freeMsgCount', types: 3 },
                ],
                [
                    { name: '签到奖励类型', value: 'signRewardType', type: 'select', types: 4 },
                    { name: '签到奖励数量', value: 'signRewardNum', types: 4 },
                    { name: '签到奖励天数', value: 'signRewardDays', types: 4 },
                    { name: '图标url', value: 'icon', types: 4 },
                    { name: '大图标url', value: 'bigIcon', types: 4 },
                ],
                [
                    { name: '免费视频个数', value: 'freeVideoCount', types: 2 },
                ],
                [
                    { name: '免费发图片数量', value: 'freeImgCount', types: 6 },
                ],
                [
                    { name: '头像框样式', value: 'avatarFrameStyle', types: 7 },
                ],
                [
                    { name: '免费查看谁喜欢你数量', value: 'whoLikeYouCount', types: 5 },
                ],
                [
                    { name: '资料卡样式', value: 'profileCardStyle', types: 9 },
                ],
                [
                    { name: '进场动画样式', value: 'entryDynamicStyle', types: 10 },
                ],
                [
                    { name: '送礼贴纸样式', value: 'giftStickerStyle', types: 11 },
                ],
                [
                    { name: '评论贴纸样式ID', value: 'commentStickerStyle', types: 12 },
                ],
                [
                    { name: '直播间列表排序优先级', value: 'liveRoomSortPriority', types: 13 },
                ],
                [
                    { name: '礼物id', value: 'vipGiftId', types: 8 },
                    { name: '会员礼物排序', value: 'vipGiftSort', types: 8 },
                ],
            ],
            detailInfo: {
                detailData: {}
            },
            getId: null,
            typesName: '',
            days: 0,
            showIndex: 0,
            importFile: '',
            importVisible: false,
            benefitList: [],
            detailList: [],
            userSignList: [],
            total: 0,
            page: 1,
            limit: 30,
        }
    },
    watch: {
        importVisible(newVal) {
            if (!newVal) {
                this.importFile = ''
            }
        }
    },
    mounted() {
        this.getSubscriptionBenefits()
        this.getBenefitList(1)
        this.getUserSigns()
        this.getSignRewardTypeList()
    },
    methods: {
        editDetail(info) {
            const infos = JSON.parse(info.benefitJson)
            const data = {};
            for (const item of this.fieldMappings[this.showIndex]) {
                data[item.value] = infos[item.value] || null
            }
            this.detailInfo.id = info.id
            this.detailInfo.detailData = data
        },
        async getSignRewardTypeList() {
            const res = await getConstList('awardType');
            if (res.code != 0) return this.$message.error(res.msg);
            this.signRewardTypeList = res.data
        },
        addDialogClose() {
            this.addDialogVisible = false
            this.addDialogInfo = {
                scene: null,
                name: null,
                description: null,
                benefitType: null,
                userSign: null,
                sort: null,
                listPicUrl: '',
                listDynamicUrl: '',
                dressPicUrl: '',
                dressDynamicUrl: '',
                status: 1,
            }
        },
        submitDialog() {
            this.$refs.addDialogForm.validate((valid) => {
                if (valid) {
                    console.log(this.addDialogInfo);
                    this.addBenefit(this.addDialogInfo, this.addDialogClose);
                }
            });
        },
        updateDialog(info) {
            this.addDialogType = 1
            this.addDialogInfo = info
            this.addDialogVisible = true
        },
        guaranteedHandleCurrentChange(page) {
            this.getBenefitList(page)
        },
        importBenefit() {
            this.importVisible = true
        },
            async uploadFile(file) {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('cover', 0)
                formData.append('dir', ' train/video')
                const { data: res } = await this.$axios.post(
                    this.$store.getters.path.hostmgr_upload +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
                    formData
                )
                return { code: res.code, url: res.data }
            },
        async copyBenefit(row) {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.config_benefit_copy,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    benefitId: row.id
                }
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('复制成功')
                this.getBenefitList()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async copyToTest(row) {
            let infos = JSON.stringify(row)
            let clipboard = new Clipboard('#btn', {
                text: function () {
                    //返回字符串
                    return infos
                },
            })
            clipboard.on('success', () => {
                //复制成功
                this.$message('复制成功')
            })
        },
        async getSubscriptionBenefits() {
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.const_all,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    className: 'com.quhong.enums.MemberBenefitType'
                },

            })
            if (res.code === 0 || res.status === 0) {
                this.subscriptionBenefits = res.data
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async getBenefitList(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.config_benefit_query,
                params: {
                    page: this.page,
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                this.benefitList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addBenefit(info, func) {
            const data = JSON.parse(JSON.stringify(info))
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_benefit_add,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.getBenefitList()
                if (func) {
                    func()
                }
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        closeDetail() {
            this.detailVisible = false
            this.detailInfo = {
                detailData: ''
            }
            this.typesName = ''
            this.days = 0
        },
        async updateDetail(info) {
            const data = {
                benefitId: info.benefitId,
                id: info.id,
                status: info.status == 0 ? 1 : 0,
                benefitType: this.detailInfo.benefitType,
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.config_benefit_detail_able,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    ...data
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.getDetailList({
                    id: data.benefitId,
                    benefitType: this.detailInfo.benefitType,
                })
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addDetail() {
            for (const item of this.fieldMappings[this.showIndex]) {
                if (!this.detailInfo.detailData[item.value]) {
                    this.$message.error('请输入' + item.name)
                    return
                }
            }
            const data = JSON.parse(JSON.stringify(this.detailInfo))

            data.detailData = JSON.stringify(data.detailData)
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_benefit_detail_submit,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.getDetailList(this.detailInfo)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async getDetailList(info, type = 0) {
            try {
                if (type == 1) {
                    this.getId = info.id
                }
                const { data: res } = await this.$axios({
                    method: 'get',
                    url: this.$store.getters.path.config_benefit_detail_list,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                        benefitId: this.getId
                    }
                })

                if (res.code !== 0 && res.status !== 0) {
                    this.$message.error(res.msg || res.message)
                    return
                }

                // 初始化详情数据
                this.detailInfo = {
                    benefitId: type == 1 ? info.id : info.benefitId,
                    benefitType: info.benefitType,
                    detailData: {}
                }

                // 处理详情列表数据
                this.detailList = res.data.details.map(item => {
                    if (item.benefitJson) {
                        try {
                            const jsonData = JSON.parse(item.benefitJson)
                            return { ...item, ...jsonData }
                        } catch (e) {
                            console.error('解析benefitJson失败:', e)
                            return item
                        }
                    }
                    return item
                })

                // 设置显示索引
                this.showIndex = this.findIndex(info.benefitType)
                this.detailVisible = true

            } catch (error) {
                console.error('获取详情列表失败:', error)
                this.$message.error('获取详情列表失败')
            }
        },
        findIndex(type) {
            for (let [index, item] of this.fieldMappings.entries()) {
                if (item[0] && item[0].types == type) {
                    return index; // 直接返回，跳出所有循环
                }
            }
            return 0; // 没找到的情况   
        },

        //获取用户标签列表
        async getUserSigns() {
            const { data: res } = await this.$axios({
                method: 'POST',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                url: this.$store.getters.path.config_userSign_query,
                data: {
                    data: {
                        signType: 'vip',
                        signTemplate: 'user',
                    },
                    page: 0,
                },
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.userSignList = res.data.list
            }
        },
    }
}
</script>
<style scoped lang="scss">
.benefit {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

    }
}
</style>